import type { RegistrationResponseJSON } from '@simplewebauthn/typescript-types';

import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';
import configRequest from '@api/requests/configRequest';

export interface AddWebAuthnMethodData extends RegistrationResponseJSON {
	name: string;
}

export type AddWebAuthnMethodResponse = void;

const addWebAuthnMethod = configRequest<AddWebAuthnMethodResponse, AddWebAuthnMethodData>({
	requestPrefix: 'mfa/addWebAuthnMethod',
	reqConfigCreator: data => ({
		data: { ...data, response: { ...data?.response, clientDataJson: data?.response.clientDataJSON } },
		url: ACCOUNT_CLIENT_API_ENDPOINTS.MFA.WEBAUTHN.ADD_WEB_AUTHN_METHOD(),
		method: HTTP_METHODS_ENUM.POST,
	}),
});

export default addWebAuthnMethod;
